import { createStateHook } from 'react-sweet-state';

import { type AISmartButtonState, AISmartButtonStore } from '../../ai-smart-button-store';

/**
 * Hook to access nudges from the AISmartButton state.
 */
export const useAINudges = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.nudges,
});

/**
 * Hook to access button clicked timestamp from the AISmartButton state.
 */
export const useAIButtonClickedTimestamp = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.buttonClickedTimestamp,
});
